import type { FC } from "react";

import { useTrustPilotConfig } from "@ui/hooks/useTrustPilotConfig";

export type TrustPilotReviewsWidgetProps = {
  disableForCurrentPage?: boolean;
  styleHeight?: string;
  styleWidth?: string;
  stars?: string;
  reviewsPerPage?: string;
  sku?: string;
};

export const TrustPilotReviewsWidget: FC<TrustPilotReviewsWidgetProps> = ({
  disableForCurrentPage = false,
  styleHeight = "150px",
  styleWidth = "100%",
  stars = "1,2,3,4,5",
  reviewsPerPage = "15",
  sku,
}) => {
  const { ref, isEnabled, localeCode, businessUnitId, templateId, leaveAReviewLink, theme } =
    useTrustPilotConfig("reviewsWidgetTemplateId");

  if (disableForCurrentPage || !isEnabled) {
    return (
      <div
        hidden
        data-testid="trustpilot-reviews-widget-fallback"
        data-debug={`${disableForCurrentPage}, ${isEnabled}`}
      >
        TrustPilot Reviews Widget not configured
      </div>
    );
  }

  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-testid="trustpilot-reviews-widget"
      data-locale={localeCode}
      data-template-id={templateId}
      data-businessunit-id={businessUnitId}
      data-theme={theme}
      data-style-height={styleHeight}
      data-style-width={styleWidth}
      data-stars={stars}
      data-reviews-per-page={reviewsPerPage}
      data-sku={sku}
    >
      <a href={leaveAReviewLink} target="_blank" rel="noopener noreferrer">
        Trustpilot
      </a>
    </div>
  );
};
